import type { FC } from 'react';
import React from 'react';
import { Typography } from '@interstate/components/Typography';
import { TextInput } from '@interstate/components/TextInput';
import { TextArea } from '@interstate/components/TextArea';
import { Box } from '@interstate/components/Box';
import { TEST_IDS } from '../../constants';

type NameTemplateProps = {
    templateName: string;
    templateDescription: string;
    setTemplateName: (templateName: string) => void;
    setTemplateDescription: (templateDescription: string) => void;
    templateNameConflictError?: string;
    setTemplateNameConflictError: (templateNameConflictError: string | undefined) => void;
};
export const NameTemplate: FC<NameTemplateProps> = ({
    templateDescription,
    setTemplateDescription,
    templateName,
    setTemplateName,
    templateNameConflictError,
    setTemplateNameConflictError
}) => {
    return (
        <Box data-testid={TEST_IDS.NAME_TEMPLATE_SECTION}>
            <Typography variant="label-sm" sx={({ tokens }) => ({ color: tokens.ComponentTextInputLabelColor })}>
                Step 1
            </Typography>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Name Template
            </Typography>
            <TextInput
                data-testid={TEST_IDS.TEMPLATE_NAME_INPUT}
                value={templateName}
                onChange={(e) => {
                    setTemplateNameConflictError(undefined);
                    setTemplateName(e.target.value);
                }}
                label="Template Name"
                name="name"
                sx={{ mb: 2 }}
                size="small"
                required
                hasError={Boolean(templateNameConflictError)}
                errorMessage={templateNameConflictError}
                customErrorMessages={{ isRequired: 'Required' }}
            />
            <TextArea
                data-testid={TEST_IDS.TEMPLATE_DESCRIPTION_INPUT}
                value={templateDescription}
                onChange={(e) => setTemplateDescription(e.target.value)}
                label="Description"
                name="description"
                rows={4}
                size="small"
                maxLength={500}
            />
        </Box>
    );
};
